import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {gsap, Linear} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";


export class ForegroundElements extends PIXI.Container implements StageLayer {

    private transitionOver: PIXI.spine.Spine;

    private currentMode: GameMode;

    private isInTransition: boolean = false;

    constructor() {
        super();
        this.name = "foregroundElements";
        this.init();
    }

    private init(): void {

        this.currentMode = GameMode.NORMAL;
        this.isInTransition = false;


        this.transitionOver = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.BG_TRANSITION_OVER));
        this.transitionOver.position.set(360, 360);
        this.transitionOver.visible = false;
        this.addChild(this.transitionOver);
        console.log("TRANSITION OVER ANIMATIONS", this.transitionOver.spineData.animations);

        this.onOrientationChanged();
        this.onResize();

        //this.playTransitionOver();
        this.playIdleLoop(XwaysHoarder2.model.mode);
    }

    public playGameIntroSpine(): gsap.core.Timeline {
        /*
             Animation {name: 'Intro/GameIntro', timelines: Array(16), duration: 4.400000095367432}
         */

        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(this.playTransitionOver("Intro/GameIntro"));
        tl.add(this.playIdleLoop(XW2GameMode.NORMAL));

        return tl;
    }

    public stopLoop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.transitionOver.state.setEmptyAnimation(0, 0);
            //this.transitionOver.state.setEmptyAnimation(1, 0);
        });

        return tl;
    }

    public playIdleLoop(gameMode: XW2GameMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        /*
            Animation {name: 'Idles/Binge Idle', timelines: Array(53), duration: 3.700000047683716}
            Animation {name: 'Idles/FS Idle', timelines: Array(84), duration: 6.6666998863220215}
            Animation {name: 'Idles/MainGame Idle', timelines: Array(110), duration: 10}
            Animation {name: 'Idles/SFS Idle', timelines: Array(80), duration: 6.6666998863220215}
     */

        switch(gameMode) {
            case XW2GameMode.NORMAL:
                tl.add(() => {
                    this.transitionOver.visible = true;
                    this.transitionOver.autoUpdate=true;
                    this.transitionOver.state.setAnimation(0, "Idles/MainGame Idle", true);
                });

                break;
            case XW2GameMode.FREESPIN:
                tl.add(() => {
                    this.transitionOver.visible = true;
                });
                tl.add(() => {
                    this.transitionOver.autoUpdate=true;
                    this.transitionOver.state.setAnimation(0, "Idles/FS Idle", true);
                });
                break;
            case XW2GameMode.SUPER_FREESPIN:
                tl.add(() => {
                    this.transitionOver.visible = true;
                });
                tl.add(() => {
                    this.transitionOver.autoUpdate=true;
                    this.transitionOver.state.setAnimation(0, "Idles/SFS Idle", true);
                });
                break;
            case XW2GameMode.BINGE_SPINS:
                tl.add(() => {
                    this.transitionOver.visible = true;
                });
                tl.add(() => {
                    this.transitionOver.autoUpdate=true;
                    this.transitionOver.state.setAnimation(0, "Idles/Binge Idle", true);
                });
                break;
        }

        return tl;
    }

    public skipped: boolean = false;

    private playTransitionOver(animName:string = "Transitions/MG FS"): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        /*
                Animation {name: 'Idles/Binge Idle', timelines: Array(53), duration: 3.700000047683716}
                Animation {name: 'Idles/FS Idle', timelines: Array(84), duration: 6.6666998863220215}
                Animation {name: 'Idles/MainGame Idle', timelines: Array(110), duration: 10}
                Animation {name: 'Idles/SFS Idle', timelines: Array(80), duration: 6.6666998863220215}
                Animation {name: 'Intro/GameIntro', timelines: Array(130), duration: 4.400000095367432}
                Animation {name: 'Transitions/Binge MG', timelines: Array(124), duration: 5.8333001136779785}
                Animation {name: 'Transitions/FS BINGE', timelines: Array(124), duration: 5.8333001136779785}
                Animation {name: 'Transitions/FS MG', timelines: Array(124), duration: 5.8333001136779785}
                Animation {name: 'Transitions/MG FS', timelines: Array(128), duration: 5.8333001136779785}
                Animation {name: 'Transitions/MG SFS', timelines: Array(125), duration: 5.8333001136779785}
                Animation {name: 'Transitions/SFS BINGE', timelines: Array(125), duration: 5.8333001136779785}
                Animation {name: 'Transitions/SFS MG', timelines: Array(124), duration: 5.8333001136779785}
         */

        tl.add(() => {
            this.transitionOver.visible = true;
        });
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.transitionOver, 0, animName,false));

        if(['Transitions/MG FS','Transitions/MG SFS', 'Transitions/SFS BINGE','Transitions/FS BINGE',
            'Transitions/Binge MG', 'Transitions/FS MG', 'Transitions/SFS MG'].indexOf(animName) > - 1) {
            tl.add(() => {
                gsap.timeline().add(() => {
                    if(!this.skipped) {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR);
                    }
                }, 0.65);
            }, "<");
        }



        if(['Transitions/MG FS','Transitions/MG SFS','Transitions/Binge MG', 'Transitions/FS MG', 'Transitions/SFS MG'].indexOf(animName) > - 1) {
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_STOP);
            });
        }



        return tl;
    }

    public makeTransition(gameMode: XW2GameMode, fromMode: XW2GameMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();


        switch (gameMode) {
            case XW2GameMode.NORMAL:
                if (fromMode === XW2GameMode.SUPER_FREESPIN) {
                    if(XwaysHoarder2.model.data.currentFSLevel < 4){
                        // current: sfs, new: base
                        tl.add(this.transitionSpineSfsToMg());
                        tl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                        }, "<");
                    }
                    else {
                        // current: binge, new: base
                        tl.add(this.transitionSpineBingeToMg());
                        tl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                        }, "<");
                    }
                } else {
                    if(XwaysHoarder2.model.data.currentFSLevel < 4){
                        // current: sfs, new: base
                        tl.add(this.transitionSpineFsToMg());
                        tl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                        }, "<");
                    }
                    else {
                        // current: binge, new: base
                        tl.add(this.transitionSpineBingeToMg());
                        tl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                        }, "<");
                    }
                    // current: fs, new: base
                    //tl.add(this.transitionSpineFsToMg(this.freespinFg, this.baseGameFg));
                }
                break;
            case XW2GameMode.RESPIN: break;
            case XW2GameMode.FREESPIN:
                tl.add(this.transitionSpineMgToFs());
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                }, "<0.2");
                break;
            case XW2GameMode.SUPER_FREESPIN:
                tl.add(this.transitionSpineMgToSfs());
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                }, "<0.2");
                break;
            case XW2GameMode.BINGE_SPINS:
                if(fromMode === XW2GameMode.SUPER_FREESPIN) {
                    tl.add(this.transitionSpineSfsToBinge());
                    tl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                    }, "<0.2");
                }
                else {
                    tl.add(this.transitionSpineFsToBinge());
                    tl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.ELEVATOR_PANEL);
                    }, "<0.2");
                }
                break;

        }

        return tl;
    }

    public setForeground(gameMode: XW2GameMode, fromMode: XW2GameMode, restore: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        /*
            private baseGameFg:PIXI.Sprite;
            private freespinFg:PIXI.Sprite;
            private bingeSpinFg:PIXI.Sprite;
            private sFreespinFg:PIXI.Sprite;
         */


        if (restore) {


            switch (gameMode) {
                case XW2GameMode.NORMAL:

                    break;
                case XW2GameMode.RESPIN:

                    break;
                case XW2GameMode.FREESPIN:

                    break;
                case XW2GameMode.SUPER_FREESPIN:

                    break;
                case XW2GameMode.BINGE_SPINS:

                    break;
            }
        } else {
            switch (gameMode) {
                case XW2GameMode.NORMAL:

                    if (fromMode === XW2GameMode.SUPER_FREESPIN) {
                        if(XwaysHoarder2.model.data.currentFSLevel===4){
                            // tl.add(this.transitionDownwardsBeforeOutro(this.bingeSpinFg, this.baseGameFg));
                        }else{
                            // tl.add(this.transitionDownwardsBeforeOutro(this.sFreespinFg, this.baseGameFg));
                        }
                    } else {
                        // tl.add(this.transitionDownwardsBeforeOutro(this.freespinFg, this.baseGameFg));

                    }
                    break;
                case XW2GameMode.RESPIN:

                    break;
                case XW2GameMode.FREESPIN:
                    //tl.add(this.transitionUpwardsPostIntro(this.baseGameFg, this.freespinFg));
                    break;
                case XW2GameMode.SUPER_FREESPIN:
                    //tl.add(this.transitionUpwardsPostIntro(this.baseGameFg, this.sFreespinFg));

                    break;
                case XW2GameMode.BINGE_SPINS:
                    if (fromMode === GameMode.NORMAL || fromMode === XW2GameMode.RESPIN) {
                        //tl.add(this.transitionUpwardsPostIntro(this.baseGameFg, this.bingeSpinFg));
                    } else if (fromMode === GameMode.FREESPIN) {
                        //tl.add(this.getTransitionAnimation(this.freespinFg, this.bingeSpinFg));
                    } else {
                        //tl.add(this.getTransitionAnimation(this.sFreespinFg, this.bingeSpinFg));
                    }
                    break;
                default:
                    break;
            }

        }


        return tl;
    }

    public onOrientationChanged() {

    }

    public onResize() {

        if (NolimitApplication.isLandscape) {
            this.transitionOver.scale.set(1, 1);
            this.transitionOver.position.y = 360;
        } else {
            this.transitionOver.scale.set(0.75, 0.75);
            this.transitionOver.position.y = 369;
        }

        if (!this.isInTransition) {
            if (NolimitApplication.isLandscape) {

            } else {

            }
        }

    }

    public transitionSpineFsToMg(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.playTransitionOver("Transitions/FS MG"));
        return tl;
    }

    public transitionSpineSfsToMg(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();


        tl.add(this.playTransitionOver("Transitions/SFS MG"));


        return tl;
    }

    public transitionSpineBingeToMg(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.playTransitionOver("Transitions/Binge MG"));
        return tl;
    }


    public transitionSpineMgToFs(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.playTransitionOver("Transitions/MG FS"));
        return tl;
    }

    public transitionSpineMgToSfs(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.playTransitionOver("Transitions/MG SFS"));

        return tl;
    }

    public transitionSpineFsToBinge(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.playTransitionOver("Transitions/FS BINGE"));

        return tl;
    }

    public transitionSpineSfsToBinge(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.playTransitionOver("Transitions/SFS BINGE"));
        return tl;
    }


    public transitionUpwardsPostIntro(currentFG: PIXI.Sprite, nextFG: PIXI.Sprite): gsap.core.Timeline {
        const transitionTl: gsap.core.Timeline = gsap.timeline();
        this.isInTransition = true;
        nextFG.visible = true;
        nextFG.alpha = 1;
        nextFG.position.set(360, -1320);
        transitionTl.to(currentFG, {duration: 1, y: 2040});
        transitionTl.to(nextFG, {duration: 1, y: 360},"<");
        transitionTl.add(() => {
            currentFG.alpha = 0;
            currentFG.visible = false;
            this.isInTransition = false;
            this.onResize();
        });

        return transitionTl;
    }

    public transitionDownwardsBeforeOutro(currentFG: PIXI.Sprite, nextFG: PIXI.Sprite): gsap.core.Timeline {
        const downTl: gsap.core.Timeline = gsap.timeline();
        this.isInTransition = true;
        nextFG.visible = true;
        nextFG.alpha = 1;
        nextFG.position.set(360, 2040);
        downTl.to(currentFG, {duration: 1, y: -1320});
        downTl.to(nextFG, {duration: 1, y: 360},"<");
        downTl.add(() => {
            currentFG.alpha = 0;
            currentFG.visible = false;
            this.isInTransition = false;
            this.onResize();
        });

        return downTl;
    }


    public screenShake(dur: number, wiggles: number = 40, isVertical: boolean, movepos?: number): gsap.core.Timeline {
        let moveXVal: number = movepos ? movepos : 5,
            moveYVal: number = movepos ? movepos : 5;
        let wiggleTl: gsap.core.Timeline = gsap.timeline(),
            x: string = Math.random() > 0.5 ? `-=${moveXVal}` : `+=${moveXVal}`,
            y: string = Math.random() > 0.5 ? `-=${moveYVal}` : `-=${moveYVal}`;

        const shakeWiggle = CustomWiggle.create("shakeWiggle", {
            wiggles: wiggles,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });
        if (!isVertical) {
            wiggleTl.to(this, {
                duration: dur,
                x: x,
                ease: shakeWiggle
            }, 0);
        }
        wiggleTl.to(this, {
            duration: dur,
            y: y,
            ease: shakeWiggle
        }, 0);
        wiggleTl.to(this, {
            x: 0,
            y: 0,
            duration: 0.01
        });

        return wiggleTl;
    }

}